// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"336":"5f6b0f0b","343":"1378b8ee","931":"e7bd89fd"}[chunkId] + ".css";
};